import { Enum, EnumType } from 'ts-jenum';

@Enum<NotificationType>('value')
export class NotificationType extends EnumType<NotificationType>() {
   static readonly SHOW = new NotificationType('SHOW');
   static readonly INFO = new NotificationType('INFO');
   static readonly WARN = new NotificationType('WARN');
   static readonly ERROR = new NotificationType('ERROR');
   static readonly SUCCESS = new NotificationType('SUCCESS');

   static getTypeByStringValue(notificationType: string): NotificationType {
      if (notificationType === 'SHOW') {
         return NotificationType.SHOW;
      }
      if (notificationType === 'INFO') {
         return NotificationType.INFO;
      }
      if (notificationType === 'WARN') {
         return NotificationType.WARN;
      }
      if (notificationType === 'ERROR') {
         return NotificationType.ERROR;
      }
      if (notificationType === 'SUCCESS') {
         return NotificationType.SUCCESS;
      }
      return NotificationType.SHOW;
   }

   private constructor(public value: string) {
      super();
   }
}
